import { createGlobalStyle } from "styled-components";


export const Container = createGlobalStyle`
    :root {
        //Primary Palette
        --color-primary: #1627A3;
        --color-second: #15AAE5;
        --color-primary-negative: #355764;

        //Grey Scale Palette
        --color-white: #ffffff;
        --color-grey-1: #EEEEEE;
        --color-grey-2: #545454; //cor dos icones
        --color-black: #000000; //icones principais

        //Feedback Palette
        --color-success: #00bf63;
        --color-error: #Ff4848;
        --color-alert: #F4C01E;

        //Fonts
        --font-primary: 'Open Sans', sans-serif;
        --font-second: 'Inter', sans-serif;
    }

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video, input, button{
        background: none;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        outline: none;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block;
    }

    body {
        line-height: 1;
        height: 100vh;
    }

    ol, ul, li {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    *{
        box-sizing: border-box;
    }

    h1{
      font-family: var(--font-primary);
    }

    span {
      font-family: var(--font-second);
      font-size: 0.8rem;
      color: var(--color-black);
    }

    button, select{
        cursor: pointer;
        border-radius: 4px;
    }
    
    a {
        text-decoration: none;
        color: inherit;
    }

    /* CLASSE DOS COMPONENTES */

    .wh-100 {
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .center{
      display: flex;
      justify-content: center;
    }

    .container {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .link {
      padding: 0.5rem 1rem;
      border-radius: 0.2rem;
      font-family: var(--font-primary);
      font-size: 0.8rem;
      font-weight: 500;
      color: var(--color-grey-1);
      background-color: var(--color-black);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .nav {
      height: 20vh;
      background-color: var(--color-primary);
      color: var(--color-white);
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      padding: 1.5rem 1rem;

      h1 {
        font-family: var(--font-primary);
        font-weight: 800;
        font-size: 2rem;
      }
      
      h4 {
        font-family: var(--font-second);
        font-weight: 400;
        font-size: 0.8rem;
      }
    }

    .cardMenu {   
      width: 95vw;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 1.5rem 0;
      justify-content: flex-start;
      
      .nome_produto{
        font-family: var(--font-primary);
        text-align: center;
      }
      
      @media (max-width:721px) {
        overflow-x: scroll;
        flex-wrap: nowrap;
        justify-content: flex-start;
      }
    }

    .card{
      width: 31%;
      height: 75vh;
      margin: 0.5rem;
      border-radius: 1rem;
      background-color: var(--color-grey-1);
      color: var(--color-black);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      border: 1px solid #ccc;

      @media (min-width:1023px) {
        width: 23%;
      }

      @media (max-width:721px) {
        height: 28rem;
        min-width: 15rem;
      }
    }
    
    .container_card {
      height: 60%;
      padding: 0.5rem 0.8rem 1rem 0.8rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media (max-width:721px) {
        height: 60%;
        padding: 1rem 0.8rem 1rem 0.8rem;
      }
    }

    .img{
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      object-fit: cover;

      @media (max-width:424px) {
        display: none;
      }
    }

    .center-class {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .button-primary {
        padding: 0.5rem 3.0rem;
        background-color: var(--color-primary);
        color: var(--color-white);
        font-family: var(--font-primary);
        font-size: 1.4rem;
        font-weight: 600;
        border-radius: 0.6rem;
    }

    .App {
        height: 100vh;
    }

    .forms {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      padding: 2.5rem 0;
      color: var(--color-grey-2);
      font-family: var(--font-primary);
    }

    .input {
        width: 90%;
        height: 8vh;
        border-radius: 1rem;
        margin: 0 auto;
        color: var(--color-black);
        padding-left: 1rem;
        background-color: var(--color-grey-1);
    }

    .select {
        width: 90%;
        height: 8vh;
        border-radius: 1rem;
        margin: 0 auto;
        color: var(--color-black);
        padding-left: 1rem;
        background-color: var(--color-grey-1);
    }

    footer{
      min-height: 4rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EEEEEE;
      font-family: Arial, Helvetica, sans-serif;
      background-color: #000000;
      padding: 0 2rem;
    }

    .container_menu {
      width: 100%;
      height: 90vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 1.5rem;

      @media (max-width:721px) {
          height: 120vh;
          display: flex;
          justify-content: flex-start;
        }
    }

    .colum1 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .sobre-nos{
          width: 50%;

          @media (max-width:721px) {
            width: 98%;
          }
        }

        .equipe-foto{
          width: 40%;
          border-radius: 2rem;

          @media (max-width:721px) {
            width: 80%;
            height: 35%;
            margin-top: 2rem;
          }
        }

        @media (max-width:721px) {
          height: 100vh;
          flex-direction: column;
        }
    }

    .H1 {
      font-size: 3rem;

      @media (max-width:721px) {
        text-align: center;
      }
    }

    .text {
      font-size: 1.2rem;
      font-family: var(--font-second);

      @media (max-width:721px) {
        width: 100%;
        text-align: justify;
        font-size: 1rem;
      }
    }

    .icones {
      width: 3rem;
      border-radius: 8px;
    }

    .contatos {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
`;
